const props = (state) => {
  return {
    store$guisOpen: state.guisOpen,
  };
};

export default props;
